/* eslint-disable no-unneeded-ternary */
import React from 'react'
import { LinkData, RecentTopicWrapper, RecentTopicHeading, RecentTopicLink } from './styles'

const RecentTopicPosts = props => {
  const { title, posts } = props
  return (
    <RecentTopicWrapper>
      <RecentTopicHeading>{title ? title : 'Recent Posts'} </RecentTopicHeading>
      {posts.map((post, index) =>
        title === 'Categories' ? (
          <RecentTopicLink href={`/articles/${post?.attributes?.url}/`} key={index}>
            <LinkData>{post?.attributes?.topicName}</LinkData>
          </RecentTopicLink>
        ) : (
          <RecentTopicLink href={post?.attributes?.url} key={index}>
            <LinkData>{post?.attributes?.articleTitle}</LinkData>
          </RecentTopicLink>
        )
      )}
    </RecentTopicWrapper>
  )
}

export default RecentTopicPosts
